const routes = [{
  path: '/access',  //识别中心
  name: 'access',
  component: () => import('@src/modules/account/main'),
  // redirect: '/Access/IdentifyCenter',
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: 'identifyCenter',//识别中心
      name: 'identifyCenter',
      component: () => import('@src/modules/identifyCenter/view/IdentifyCenter'),
      meta: {
        requireAuth: true,
        // routerAlive: true
      }
    }, 
    {
      path: 'identifyRecord',//识别记录
      name: 'identifyRecord',
      component: () => import('@src/modules/identifyCenter/view/IdentifyRecord'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: 'markingRecord',//标记记录
      name: 'markingRecord',
      component: () => import('@src/modules/identifyCenter/view/markingRecord'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
  ]
}]

export default routes
